/*
 * View for the Learner
 */

define(["jquery", "marionette", "modules/learner/template/learnerTemplate.html"], function (
  $,
  Marionette,
  LearnerTemplate,
) {
  "use strict";

  const LearnerView = {};

  LearnerView.learnerLayout = Marionette.Layout.extend({
    template: LearnerTemplate,
    regions: {
      learnerConfig: "#learnerConfig",
      learnerResults: "#learnerResults",
      learnerFilters: "#learnerFilters",
    },
    setJobStatusMessage: function (messageKey, messageArgs) {
      if (messageArgs) {
        $("#learnerJobStatusMessage").text($.t(messageKey, messageArgs));
      } else {
        $("#learnerJobStatusMessage").text($.t(messageKey));
      }
    },
  });

  return LearnerView;
});
